<template>
  <div class="max-h-[24px]">
    <button v-if="favoritedSitter" aria-label="Unfavorite sitter" @click="unfavoriteSitter">
      <HeartIcon color="#4B4C52" class="mt-auto mb-auto" />
    </button>
    <button v-else aria-label="Favorite sitter" @click="favoriteSitter">
      <HeartOutlineIcon color="#4B4C52" class="mt-auto mb-auto" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useMutation } from '@vue/apollo-composable';
import HeartIcon from '@/graphics/icons/HeartIcon.vue';
import HeartOutlineIcon from '@/graphics/icons/HeartOutlineIcon.vue';
import { ADD_FAVORITE_SITTER, REMOVE_FAVORITE_SITTER } from '@/graphql/provider/profile/queries';
import { sendSegmentEvent } from '@/lib/segment';
import {
  PARENT_PROFILE_FAVORITED_SITTER_EVENT,
  PARENT_PROFILE_UNFAVORITED_SITTER_EVENT,
} from '@/lib/constants/favoriteSitterEvents';

defineOptions({ name: 'FavoriteSitterButton' });
const props = withDefaults(defineProps<{ favoritedSitter?: boolean; sitterAccountId: string }>(), {
  favoritedSitter: false,
});
const emit = defineEmits<{ favoritedSitterChange: [isFavorited: boolean] }>();

const { mutate: addFavoriteSitter } = useMutation(ADD_FAVORITE_SITTER);
const { mutate: removeFavoriteSitter } = useMutation(REMOVE_FAVORITE_SITTER);

async function favoriteSitter(): Promise<void> {
  try {
    await addFavoriteSitter({ providerId: props.sitterAccountId });
    emit('favoritedSitterChange', true);
    sendSegmentEvent(PARENT_PROFILE_FAVORITED_SITTER_EVENT, { sitter_uuid: props.sitterAccountId });
  } catch (error) {
    console.error(error);
  }
}

async function unfavoriteSitter(): Promise<void> {
  try {
    await removeFavoriteSitter({ providerId: props.sitterAccountId });
    emit('favoritedSitterChange', false);
    sendSegmentEvent(PARENT_PROFILE_UNFAVORITED_SITTER_EVENT, { sitter_uuid: props.sitterAccountId });
  } catch (error) {
    console.error(error);
  }
}
</script>
